import { render, staticRenderFns } from "./courseIntroComponent.vue?vue&type=template&id=0ac4c694"
import script from "./courseIntroComponent.vue?vue&type=script&lang=js"
export * from "./courseIntroComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports